export const reportDetailsSelectors = {
	isAllSelected: (state) => state.reports.details.isAllSelected,
	detailsList: (state) => state.reports.details.detailsList,
	selectedRecords: (state) => state.reports.details.selectedRecords,
	filters: (state) => state.reports.details.filters,
	query: (state) => state.reports.details.query,
	abKeyReportValue: (state) => state.reports.details.abKeyReportValue
};
